<script>
import { ref } from "vue";
const value = ref();
const currentDate = ref(new Date());
export default {
  data() {
    return {
      startdate: currentDate,
      dateFormat: "dd-MM-yyyy",
      showFilterInputs: false,
      PendSel: ["Status", "Completed", "Pending", "Failed"],
      ServiceSelc: ["Service", "Computer Repair", "Car Repair Services"],
      SelecTrans: ["Customer", "Lori Broaddus", "Anthony Lewis"],
      TransSelec: ["Transaction ID", "TXID24081032", "TXID24081054"],
    };
  },
  methods: {
    toggleFilterInputs() {
      this.showFilterInputs = !this.showFilterInputs;
    },
  },
};
</script>
<template>
  <div class="provider-page">
    <provider-sidebar></provider-sidebar>
    <provider-header></provider-header>
    <!-- Page Wrapper -->
    <div class="page-wrapper">
      <div class="content">
        <div
          class="d-flex align-items-center justify-content-between flex-wrap row-gap-3 mb-4"
        >
          <h4>Transaction</h4>
          <div class="d-flex align-items-center flex-wrap row-gap-3">
            <p class="text-dark me-2 mb-0">Sort</p>
            <div class="dropdown me-2">
              <a
                href="javascript:void(0);"
                class="dropdown-toggle"
                data-bs-toggle="dropdown"
              >
                Newly Added
              </a>
              <div class="dropdown-menu">
                <a href="javascript:void(0);" class="dropdown-item active">Newly Added</a>
                <a href="javascript:void(0);" class="dropdown-item">Oldest</a>
              </div>
            </div>
            <div class="dropdown me-2">
              <a
                href="javascript:void(0);"
                class="dropdown-toggle"
                data-bs-toggle="dropdown"
              >
                Export
              </a>
              <div class="dropdown-menu">
                <a href="javascript:void(0);" class="dropdown-item active">Export</a>
                <a href="javascript:void(0);" class="dropdown-item">Import</a>
              </div>
            </div>
            <a
              href="javascript:void(0);"
              class="tags d-flex justify-content-center align-items-center border rounded me-2"
              ><i class="ti ti-printer"></i
            ></a>
            <a
              href="javascript:void(0);"
              class="tags d-flex justify-content-center align-items-center border rounded"
              id="filter_search"
              @click="toggleFilterInputs"
              ><i class="ti ti-sort-descending"></i
            ></a>
          </div>
        </div>
        <div
          id="filter_inputs"
          v-bind:style="{ display: showFilterInputs ? 'block' : 'none' }"
        >
          <div class="row">
            <div class="col-lg-3 col-md-6 col-xl">
              <div class="mb-3">
                <div class="sel-cal Calendar-icon">
                  <span><i class="ti ti-calendar-month"></i></span>
                  <date-picker
                    v-model="startdate"
                    placeholder=""
                    class="datetimepicker form-control"
                    :editable="true"
                    :clearable="false"
                    :input-format="dateFormat"
                  />
                </div>
              </div>
            </div>
            <div class="col-lg-3 col-md-6 col-xl">
              <div class="mb-3">
                <vue-select
                  :options="TransSelec"
                  id="transselc"
                  placeholder="Transaction ID"
                />
              </div>
            </div>
            <div class="col-lg-3 col-md-6 col-xl">
              <div class="mb-3">
                <vue-select
                  :options="SelecTrans"
                  id="selectrans"
                  placeholder="Customer"
                />
              </div>
            </div>
            <div class="col-lg-3 col-md-6 col-xl">
              <div class="mb-3">
                <vue-select
                  :options="ServiceSelc"
                  id="serviceselec"
                  placeholder="Service"
                />
              </div>
            </div>
            <div class="col-lg-3 col-md-6 col-xl">
              <div class="mb-3">
                <vue-select :options="PendSel" id="pendsel" placeholder="Status" />
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="provide-table manage-table">
            <div class="table-responsive">
              <table class="table datatable">
                <thead class="thead-light">
                  <tr>
                    <th>Transaction ID</th>
                    <th>Customer Name</th>
                    <th>Service</th>
                    <th>Date</th>
                    <th>Payment Method</th>
                    <th>Amount</th>
                    <th>Status</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>
                      <a
                        href="javascript:void(0);"
                        data-bs-toggle="modal"
                        data-bs-target="#transaction-detail"
                        >TXID24081032</a
                      >
                    </td>
                    <td>Lori Broaddus</td>
                    <td>
                      <h6 class="fs-14 fw-normal">Computer Repair</h6>
                    </td>
                    <td>07 Oct 2024 11:22:51</td>
                    <td>Paypal</td>
                    <td>$300</td>
                    <td>
                      <div class="d-flex align-items-center">
                        <span class="badge badge-success-100 d-flex align-items-center"
                          ><i class="ti ti-point-filled"></i>Completed</span
                        >
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <a
                        href="javascript:void(0);"
                        data-bs-toggle="modal"
                        data-bs-target="#transaction-detail"
                        >TXID24081054</a
                      >
                    </td>
                    <td>Anthony Lewis</td>
                    <td>
                      <h6 class="fs-14 fw-normal">Car Repair Services</h6>
                    </td>
                    <td>15 Oct 2024 11:22:51</td>
                    <td>Credit Card</td>
                    <td>$500</td>
                    <td>
                      <div class="d-flex align-items-center">
                        <span class="badge badge-skyblue d-flex align-items-center"
                          ><i class="ti ti-point-filled"></i>Pending</span
                        >
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <a
                        href="javascript:void(0);"
                        data-bs-toggle="modal"
                        data-bs-target="#transaction-detail"
                        >TXID24081062</a
                      >
                    </td>
                    <td>Harvey Smith</td>
                    <td>
                      <h6 class="fs-14 fw-normal">Steam Car Wash</h6>
                    </td>
                    <td>24 Oct 2024 11:22:51</td>
                    <td>Paypal</td>
                    <td>$400</td>
                    <td>
                      <div class="d-flex align-items-center">
                        <span
                          class="badge badge-danger-transparent d-flex align-items-center"
                          ><i class="ti ti-point-filled"></i>Failed</span
                        >
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <a
                        href="javascript:void(0);"
                        data-bs-toggle="modal"
                        data-bs-target="#transaction-detail"
                        >TXID24081056</a
                      >
                    </td>
                    <td>Linda Ray</td>
                    <td>
                      <h6 class="fs-14 fw-normal">House Cleaning</h6>
                    </td>
                    <td>04 Nov 2024 11:22:51</td>
                    <td>COD</td>
                    <td>$430</td>
                    <td>
                      <div class="d-flex align-items-center">
                        <span class="badge badge-success-100 d-flex align-items-center"
                          ><i class="ti ti-point-filled"></i>Completed</span
                        >
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <a
                        href="javascript:void(0);"
                        data-bs-toggle="modal"
                        data-bs-target="#transaction-detail"
                        >TXID24081040</a
                      >
                    </td>
                    <td>Elliot Murray</td>
                    <td>
                      <h6 class="fs-14 fw-normal">Building Construction</h6>
                    </td>
                    <td>13 Nov 2024 11:22:51</td>
                    <td>Paypal</td>
                    <td>$600</td>
                    <td>
                      <div class="d-flex align-items-center">
                        <span class="badge badge-skyblue d-flex align-items-center"
                          ><i class="ti ti-point-filled"></i>Pending</span
                        >
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <a
                        href="javascript:void(0);"
                        data-bs-toggle="modal"
                        data-bs-target="#transaction-detail"
                        >TXID24081028</a
                      >
                    </td>
                    <td>Connie Waters</td>
                    <td>
                      <h6 class="fs-14 fw-normal">Interior Designing</h6>
                    </td>
                    <td>20 Nov 2024 11:22:51</td>
                    <td>Credit Card</td>
                    <td>$550</td>
                    <td>
                      <div class="d-flex align-items-center">
                        <span class="badge badge-success-100 d-flex align-items-center"
                          ><i class="ti ti-point-filled"></i>Completed</span
                        >
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <a
                        href="javascript:void(0);"
                        data-bs-toggle="modal"
                        data-bs-target="#transaction-detail"
                        >TXID24081075</a
                      >
                    </td>
                    <td>Lori Broaddus</td>
                    <td>
                      <h6 class="fs-14 fw-normal">Commercial Painting</h6>
                    </td>
                    <td>08 Dec 2024 11:22:51</td>
                    <td>Paypal</td>
                    <td>$380</td>
                    <td>
                      <div class="d-flex align-items-center">
                        <span
                          class="badge badge-danger-transparent d-flex align-items-center"
                          ><i class="ti ti-point-filled"></i>Failed</span
                        >
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <div
            class="table-paginate d-flex justify-content-between align-items-center flex-wrap row-gap-3"
          >
            <div class="value d-flex align-items-center">
              <span>Show</span>
              <select>
                <option>7</option>
              </select>
              <span>entries</span>
            </div>
            <div class="d-flex align-items-center justify-content-center">
              <span class="me-2 text-gray-9">1 - 07 of 10</span>
              <nav aria-label="Page navigation">
                <ul class="paginations d-flex justify-content-center align-items-center">
                  <li class="page-item me-2">
                    <a
                      class="page-link-1 active d-flex justify-content-center align-items-center"
                      href="javascript:void(0);"
                      >1</a
                    >
                  </li>
                  <li class="page-item me-2">
                    <a
                      class="page-link-1 d-flex justify-content-center align-items-center"
                      href="javascript:void(0);"
                      >2</a
                    >
                  </li>
                  <li class="page-item">
                    <a
                      class="page-link-1 d-flex justify-content-center align-items-center"
                      href="javascript:void(0);"
                      >3</a
                    >
                  </li>
                </ul>
              </nav>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- /Page Wrapper -->
  </div>
</template>
